import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { useFormErrorMessageHandler } from '@/utils/form';
import { ref, PropType, computed } from 'vue';
import { required } from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { ElAlert, ElNotification } from 'element-plus';

import {
  NkStack,
  NkGroup,
  NkForm,
  NkFormItem,
  NkInputText,
  NkButton
} from '@/core/components';

import { useDeleteDeviceMutation, useGetDeviceQuery } from '@/entities/device/hooks';
import { useFormDelete } from '@/hooks/forms';
import { useForm } from '@/core/hooks/forms';

import { Device } from '@/entities/device/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceDeleteForm',
  props: {
  id: {
    type: Number as PropType<Device['id']>,
    required: true,
    default: null,
  },
},
  emits: ['submitted'],
  setup(__props, { emit }) {

const props = __props




const { onSubmitted } = useForm(emit);

const queryData = computed(() => ({ id: props.id }));
const hasQueryData = computed(() => !!queryData.value.id);
const {
  data: device,
  isLoading: isDeviceLoading,
} = useGetDeviceQuery(queryData, { enabled: hasQueryData });

const form = ref();

const { t } = useI18n();
const router = useRouter();

const deviceRedirectionAfterDelete = computed(() => {
  if (device.value?.parent)
    return { name: 'visionair-device', params: { device: device.value?.parent } };

  return { name: 'visionair-device-group', params: { deviceGroup: device.value?.deviceGroup } };
});

const {
  mutation: { mutateAsync, isError, error: deleteDeviceError, isLoading },
  fields,
  rules,
  canDelete,
} = useFormDelete({
  queryData,
  mutationHook: useDeleteDeviceMutation,
  queryHook: useGetDeviceQuery,
  fields: {
    deviceValues: {
      0: {
        value: '',
      },
    },
  },
  rules: {
    deviceValues: {
      0: {
        value: required,
      },
    },
  },
  canDeleteValue: 'name',
  canDeleteValuePath: 'deviceValues[0].value',
});
const { error } = useFormErrorMessageHandler(deleteDeviceError);

const description = computed(() => `"${ device.value?.deviceValues?.find(o => o.reference === 'name')?.value || '-' }"`);

const submit = () => {
  form.value.validator.$validate().then((valid: boolean) => {
    if (valid && !isLoading.value) {
      mutateAsync({
        id: props.id,
      }, {
        onSuccess: () => ElNotification({
          title: t('user.notification.delete.title'),
          message: t('user.notification.delete.message'),
          type: 'success',
          position: 'bottom-right',
        }),
      }).then((res) => {
        router.push(deviceRedirectionAfterDelete.value);
        onSubmitted(res);
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkStack), null, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(ElAlert), {
            key: 0,
            title: _unref(error),
            type: "error"
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkForm), {
        ref_key: "form",
        ref: form,
        fields: _unref(fields),
        rules: _unref(rules)
      }, {
        footer: _withCtx(() => [
          _createVNode(_unref(NkGroup), { position: "right" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
                type: "danger",
                disabled: !_unref(canDelete),
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.delete')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])), [
                [_directive_loading, _unref(isLoading)]
              ])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(ElAlert), {
            title: _ctx.$t('forms.delete.warning'),
            description: _unref(description),
            type: "error",
            closable: false,
            effect: "dark"
          }, null, 8, ["title", "description"]),
          _createVNode(_unref(NkFormItem), {
            prop: "name",
            label: _ctx.$t('device.form.label.delete_type_to_continue')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                modelValue: _unref(fields).deviceValues[0].value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(fields).deviceValues[0].value) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["fields", "rules"])
    ]),
    _: 1
  })), [
    [_directive_loading, _unref(isDeviceLoading)]
  ])
}
}

})